<template>
    <div class="main-content detail">
        <div class="container">
            <div class="form" v-if="!save_btn_loading">
                <div class="form-hor">
                    <div class="form-col">
                        <custom-input
                            @change="set_value"
                            input_type="text"
                            :invalid="errors && errors.includes('name')"
                            :value="event.name"
                            :required="true"
                            limit="60"
                            hint="Hint! Max 60 characters"
                            :capitalize="true"
                            error_msg="Error! This field is mandatory"
                            name="name"
                            label="Event name"
                        ></custom-input>
                    </div>
                </div>
                <div class="form-hor">
                    <div class="form-col">
                        <dropdown
                            @selected="set_drop_value"
                            :value="event.event_type"
                            name="event_type"
                            label="Choose event type"
                            :options="event_type_options"
                        ></dropdown>
                        <custom-input
                            @change="set_value"
                            :value="event.budget"
                            :required="false"
                            name="budget"
                            limit="20"
                            min="0"
                            hint="Hint! Max 20 integers"
                            input_type="number"
                            unit="EUR"
                            label="Event budget, €"
                        ></custom-input>
                        <dropdown
                            @selected="set_drop_value"
                            :value="event.recurring"
                            unsort="true"
                            name="recurring"
                            label="Recurring"
                            :options="event_recurring_options"
                        ></dropdown>
                    </div>
                    <div class="form-col">
                        <custom-input
                            @change="set_value"
                            datepicker="true"
                            icon_class="icon icon-calendar"
                            input_type="datepicker"
                            error_msg="Error! This field is mandatory"
                            :invalid="errors && errors.includes('date')"
                            :value="event.date"
                            :required="true"
                            name="date"
                            type="text"
                            label="Event date"
                        ></custom-input>

                        <custom-input
                            @change="set_value"
                            :value="event.time"
                            :required="true"
                            :invalid="errors && errors.includes('time')"
                            name="time"
                            error_msg="Error! This field is mandatory and must include hours and minutes"
                            timepicker="true"
                            icon_class="icon icon-time"
                            label="Event time"
                        ></custom-input>

                        <custom-input
                            @change="set_value"
                            :capitalize="true"
                            limit="60"
                            input_type="text"
                            hint="Hint! Max 60 characters"
                            :value="event.location"
                            :required="false"
                            name="location"
                            label="Event location"
                        ></custom-input>
                    </div>
                </div>
                <div class="form-hor">
                    <div class="form-col">
                        <custom-textarea
                            :capitalize="true"
                            limit="250"
                            hint="Hint! Max 250 characters"
                            :punctuation_capitalization="true"
                            @change="set_value"
                            label="Add free text notes..."
                            :value="event.notes"
                            name="notes"
                        ></custom-textarea>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="loading-container">
                    <div id="loading"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import customTextarea from "@/components/pages/custom-textarea.vue";

export default {
    name: "events-add",
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_empty_event();
            vm.get_logged_in_user();
            next();
        });
    },
    components: { dropdown, customInput, customTextarea },
    computed: {
        ...mapState(["is_logged_in", "user"]),
        ...mapState("StoreEvent", [
            "event",
            "errors",
            "event_type_options",
            "event_recurring_options",
            "save_btn_loading"
        ])
    },
    data() {
        return {
            scoped_event: {
                ...this.event
            }
        };
    },
    mounted() {
        if (this.$route.params && this.$route.params.id) {
            this.get_current_event(this.$route.params.id);
            this.$route.meta.back_link = "/events/" + this.$route.params.id;
        }
    },

    methods: {
        ...mapMutations("StoreEvent", ["clear_event", "set_btn_mode", "update_field"]),
        ...mapActions(["get_logged_in_user"]),
        ...mapActions("StoreEvent", ["get_event"]),

        get_current_event(event_id) {
            this.get_event(event_id);
        },
        forward(event) {
            const b = this.$refs.dp;
            b.dispatchEvent(new MouseEvent(event.type, event));
        },
        set_drop_value(payload) {
            this.update_field({
                prop_name: payload.name,
                prop_value: payload.value
            });
        },
        set_value(args) {
            this.update_field(args);
            if (this.validateEvent()) {
                this.set_btn_mode(true);
            } else {
                this.set_btn_mode(false);
            }
        },
        set_empty_event() {
            this.clear_event();
        },
        validateEvent() {
            if (this.event.name && this.event.time && this.event.date && /^\d{2}:\d{2}$/.test(this.event.time)) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>
<style scoped>
textarea.form-input {
    min-height: 193px;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}
</style>
